import {useEffect, useMemo, useState} from "react";
import {useIsTabVisible} from "../../../hooks/useIsTabVisible";
import {getThingCameraPresenceTimeout} from "../../../utils/CameraUtils";
import {
    openStream,
    closeStream,
} from "../../../IOT/device-functions/CameraFunctions";

const PRESENCE_TIMEOUT = getThingCameraPresenceTimeout();

/**
 * @param {string} gatewayId
 * @param {string} deviceId
 * @return {{loading: boolean, error: boolean}}
 */
const useCameraPresence = (gatewayId, deviceId) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const isTabVisible = useIsTabVisible();

    useEffect(() => {
        if (!gatewayId || !deviceId || !isTabVisible) return;

        const watchStream = async () => {
            try {
                await openStream(gatewayId, {DevID: deviceId});
                setError(false);
            } catch (err) {
                console.error(err.message);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        watchStream().catch((err) => console.error(err));

        const intervalId = setInterval(watchStream, PRESENCE_TIMEOUT);

        return () => {
            clearInterval(intervalId);
            closeStream(gatewayId, {DevID: deviceId}).catch((err) =>
                console.error(err)
            );
        };
    }, [gatewayId, deviceId, isTabVisible]);

    return useMemo(() => ({loading, error}), [loading, error]);
};

export default useCameraPresence;
